import React from 'react';
import {MovieDetail, Container} from '../../components';

const DetailsMoviePage = () =>
<>
<Container>
<MovieDetail />
</Container>
</>;

export default DetailsMoviePage;